// extracted by mini-css-extract-plugin
export default {"header":"sx","fullPage":"tx","closed":"ux","minimize":"vx","redcircle":"wx","container":"xx","text":"yx","centered":"zx","escapex":"Ax"};
    if(module.hot) {
      // 1743628922833
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  